import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@air/component-skeleton";
import dynamic from "next/dynamic";
import { memo } from "react";
import { usePDFOutlineContext } from "~/components/AssetModalV2/Content/Footer/contexts/PDFOutlineContext";
// Dynamic import of the PDF outline components to avoid SSR issues
const PDFViewerOutline = dynamic(()=>import("@air/react-pdfjs-viewer/src/components/PDFViewerOutline/PDFViewerOutline").then((mod)=>mod.PDFViewerOutline), {
    loadableGenerated: {
        webpack: ()=>[
                require.resolveWeak("@air/react-pdfjs-viewer/src/components/PDFViewerOutline/PDFViewerOutline")
            ]
    },
    ssr: false,
    loading: ()=>/*#__PURE__*/ _jsx("div", {
            className: "flex items-center justify-center p-4 text-grey-10",
            children: "Loading outline..."
        })
});
export const PDFOutlinePanel = /*#__PURE__*/ memo(()=>{
    const { currentPage, numPages, changePage, pdfDocument, pdfPagesCacheRef, renderOutlinePageMenu } = usePDFOutlineContext();
    // Only render if we have PDF data - panel visibility is controlled elsewhere
    if (!pdfDocument || !pdfPagesCacheRef) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "size-full overflow-hidden",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "mb-2 text-14 font-semibold text-grey-10",
                    children: "PDF Pages"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "h-[calc(100%-2rem)] overflow-hidden",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "w-full flex-1 overflow-y-auto scrollbar scrollbar-track-grey-2 scrollbar-thumb-grey-7 [&:not(:hover)]:scrollbar-track-transparent",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "space-y-2 px-6 py-2",
                            children: Array.from({
                                length: 3
                            }).map((_, index)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "flex h-[108px] w-full flex-col items-center justify-center rounded bg-grey-1 px-0.5 pt-0.5",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex size-full items-center justify-center rounded bg-black",
                                            children: /*#__PURE__*/ _jsx(Skeleton, {
                                                width: 64,
                                                height: 92,
                                                variant: "square"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "py-2",
                                            children: /*#__PURE__*/ _jsx(Skeleton, {
                                                width: 48,
                                                height: 12,
                                                variant: "square"
                                            })
                                        })
                                    ]
                                }, index))
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "size-full overflow-hidden",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mb-2 text-14 font-semibold text-grey-10",
                children: "PDF Pages"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "h-[calc(100%-2rem)] overflow-hidden",
                children: /*#__PURE__*/ _jsx(PDFViewerOutline, {
                    pagesCount: numPages,
                    pdfPageCacheRef: pdfPagesCacheRef,
                    isOpen: true,
                    currentPage: currentPage,
                    onPageClick: changePage,
                    renderOutlinePageMenu: renderOutlinePageMenu
                })
            })
        ]
    });
});
PDFOutlinePanel.displayName = "PDFOutlinePanel";
